"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var userAuthRouter = {
  path: '/auth',
  component: _layout.default,
  redirect: '/auth/user',
  name: 'jurisdiction',
  alwaysShow: true,
  meta: {
    title: 'Privileges',
    icon: 'organization'
  },
  children: [{
    path: 'user',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/user/UserIndex'));
      });
    },
    name: 'userIndex',
    meta: {
      title: 'UserList',
      icon: ''
    }
  }, {
    path: 'orgGroup',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/org/OrgGroupIndex'));
      });
    },
    name: 'orgGroupIndex',
    meta: {
      title: 'OrganRoles'
    }
  }, {
    path: 'org',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/org/OrgIndex'));
      });
    },
    name: 'orgIndex',
    meta: {
      title: 'OrganManagement'
    }
  }, {
    path: 'role',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/role/RoleIndex'));
      });
    },
    name: 'roleIndex',
    meta: {
      title: 'RoleManagement'
    }
  }, {
    path: 'res',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/res/ResIndex'));
      });
    },
    name: 'resIndex',
    meta: {
      title: 'ResManagement'
    }
  }, {
    path: 'deptStaff',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/staff/DeptStaffIndex.vue'));
      });
    },
    name: 'deptStaffIndex',
    meta: {
      title: 'DeptStaff'
    }
  }, {
    path: 'authOrg',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/auth/authOrg/index.vue'));
      });
    },
    name: 'authOrg',
    meta: {
      title: 'authOrg'
    }
  }]
};
var _default = exports.default = userAuthRouter;